import { MatchPage } from "@/features/match/pages/Match";

const Match = () => {
  return <MatchPage />;
};

export default Match;
